import { observer } from 'mobx-react-lite';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { getIconCSSForFileProvider, FileProviderIconSize } from 'owa-fileprovider-icon';
import type AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import * as React from 'react';
import { getColumnFlexContainerStyle } from '../utils/getColumnFlexContainerStyle';

import styles from './FileProvidersToAddListView.scss';

export interface FileProviderToAddInfo {
    providerType: AttachmentDataProviderType;
    providerName: string;
    onClick: () => void;
}

export interface FileProvidersToAddListViewProps {
    providersToAddInfo: FileProviderToAddInfo[];
}

const FileProvidersToAddListView = observer(function FileProvidersToAddListView(
    props: FileProvidersToAddListViewProps
) {
    return (
        <div className={styles.container}>
            {props.providersToAddInfo.map(info => {
                const icon = getIconCSSForFileProvider(
                    info.providerType,
                    false /* disabled */,
                    FileProviderIconSize.Large
                );

                return (
                    <DefaultButton
                        key={info.providerType}
                        className={styles.providerContainer}
                        styles={getColumnFlexContainerStyle()}
                        title={info.providerName}
                        onClick={info.onClick}>
                        <div className={styles.providerIcon}>{icon}</div>
                        <div className={styles.providerName}>{info.providerName}</div>
                    </DefaultButton>
                );
            })}
        </div>
    );
});
export default FileProvidersToAddListView;
